export default {
    username: '企業コード',
    password: 'パスワード',
    rememberCode: '企業コードを保存',
    rememberPassword: 'パスワードを保存',
    showPassword: 'パスワードを表示'
};
